import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronDown } from "lucide-react";

interface CityComboboxProps {
  cities: string[];
  value: string | null;
  onChange: (city: string | null) => void;
}

export function CityCombobox({ cities, value, onChange }: CityComboboxProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 text-xs gap-1 w-44 justify-between font-normal">
          <span className="truncate">{value || "Todas as cidades"}</span>
          <ChevronDown className="h-3 w-3 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-0" align="start">
        <Command>
          <CommandInput placeholder="Buscar cidade..." className="h-8 text-xs" />
          <CommandList>
            <CommandEmpty className="py-3 text-xs">Nenhuma cidade</CommandEmpty>
            <CommandGroup>
              <CommandItem
                onSelect={() => { onChange(null); setOpen(false); }}
                className="text-xs"
              >
                <Check className={`mr-2 h-3.5 w-3.5 ${!value ? "opacity-100" : "opacity-0"}`} />
                Todas as cidades
              </CommandItem>
              {cities.map((city) => (
                <CommandItem
                  key={city}
                  onSelect={() => { onChange(city); setOpen(false); }}
                  className="text-xs"
                >
                  <Check className={`mr-2 h-3.5 w-3.5 ${value === city ? "opacity-100" : "opacity-0"}`} />
                  {city}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
